import { useSearchParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { getDoc, doc, getDocs } from "firebase/firestore";
import { db } from "../../services/firebase";
import style from "./LeadConfirm.module.css";
import StaticField from "../../components/static-field/StaticField";
import { Button, Link } from "@mui/material";
import HeaderAffida from "../../components/header/HeaderAffida";
import { collection, query, where } from "@firebase/firestore";
import { subDays } from "date-fns";
import { apiClient } from "../../services/api";

function LeadConfirm() {
  const [searchParams] = useSearchParams();
  const leadId = searchParams.get("leadId");
  const navigate = useNavigate();

  const [privacyConsent, setPrivacyConsent] = useState(false);
  const [trattamentoConsent, setTrattamentoConsent] = useState(false);
  const [sending, setSending] = useState(false);
  const [submitMessage, setSubmitMessage] = useState<string | null>(null);

  const handleSubmitConsent = async () => {
    if (!leadId) return;

    setSending(true);
    setSubmitMessage(null);

    try {
      const payload = {
        leadId,
        privacyConsent: true,
        trattamentoConsent: true,
        userAgent: navigator.userAgent,
      };
      const res = await apiClient.post(`/v1/leads/allow-privacy`, payload, {
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_PRIVACY_API_KEY ?? "",
        },
      });

      if (res.data.ok) {
        navigate("/thank-you", {
          state: {
            title: "Grazie per aver confermato i tuoi dati",
            message: "Un consulente ti contatterà al più presto 🤓",
          },
        });
      } else {
        setSubmitMessage(`Errore raccolta privacy`);
      }
    } catch (err) {
      console.error("Errore invio consenso:", err);
      setSubmitMessage("Errore durante l'invio.");
    } finally {
      setSending(false);
    }
  };

  const [leadData, setLeadData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState<string | null>(null);

  const [shouldRedirect, setShouldRedirect] = useState(false);
  const [redirectState, setRedirectState] = useState<{
    title: string;
    message: string;
  } | null>(null);

  useEffect(() => {
    let isMounted = true;

    if (!leadId) {
      setErrore("Lead ID mancante");
      setLoading(false);
      return;
    }

    const fetchLead = async () => {
      try {
        const docRef = doc(db, "leads", leadId);
        const docSnap = await getDoc(docRef);

        if (!docSnap.exists()) {
          if (isMounted) setErrore("Lead non trovato");
          return;
        }

        const lead = docSnap.data();
        if (isMounted) setLeadData(lead);
        const consensoCollRef = collection(db, "consensi");
        const thirtyDaysAgo = subDays(new Date(), 30);

        const q = query(consensoCollRef, where("leadId", "==", leadId));
        const snapshot = await getDocs(q);
        const consensi = snapshot.docs.map((doc) => doc.data());

        const consensoRecente = consensi.some(
          (c) => c.createdAt?.toDate?.() >= thirtyDaysAgo,
        );

        if (consensoRecente && isMounted) {
          setRedirectState({
            title: "Grazie per la rinnovata fiducia!",
            message:
              "Abbiamo già raccolto il tuo consenso negli ultimi 30 giorni, non serve rinnovarlo 🤓",
          });
          setShouldRedirect(true);
          return;
        }
      } catch (err) {
        console.error("Errore durante il recupero dei dati:", err);
        if (isMounted) setErrore("Errore durante il recupero dei dati");
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchLead();

    return () => {
      isMounted = false;
    };
  }, [leadId]);

  useEffect(() => {
    if (shouldRedirect && redirectState) {
      navigate("/thank-you", { state: redirectState });
    }
  }, [shouldRedirect, redirectState, navigate]);

  if (loading)
    return (
      <div className="container">
        <p>Caricamento...</p>
      </div>
    );
  if (errore)
    return (
      <div className="container">
        <p>{errore}</p>
      </div>
    );

  return (
    <div className="container">
      <HeaderAffida />
      <div className={style.confirmMainBox}>
        <div className={style.box}>
          <h2 style={{ fontSize: "26px" }}>
            Verifica i dati e conferma il tuo appuntamento
          </h2>
          <span
            style={{
              fontSize: "18px",
              color: "#656565",
              fontWeight: 300,
              lineHeight: "24px",
            }}
          >
            Un nostro agente la contatterà il prima possibile oppure all'orario
            concordato. Affida SRL è una società autorizzata ad operare,
            iscritta all'Organismo di controllo Agenti e Mediatori.
          </span>
          <div className={"flex-row gap-1"} style={{ marginTop: "1em" }}>
            <span style={{ fontSize: "11px", color: "#656565" }}>
              Vuoi leggere la nostra Privacy Policy?
            </span>
            <Link
              href={"https://www.affida.credit/pagine/privacy-policy"}
              style={{ fontSize: "11px" }}
            >
              Clicca qui.
            </Link>
          </div>
        </div>
        <div
          className={style.box}
          style={{
            border: "1px solid #d1d1d1",
            padding: ".5em 1em",
            borderRadius: ".5em",
          }}
        >
          <StaticField
            label="Nome"
            value={leadData.nome.toUpperCase()}
          ></StaticField>
          <StaticField
            label="Cognome"
            value={leadData.cognome.toUpperCase()}
          ></StaticField>
          <StaticField
            label="Cellulare"
            value={leadData.cellulare}
          ></StaticField>
        </div>
        {/*<div className={style.privacyNotice}>*/}
        {/*  <p>{PrivacyPolicy}</p>*/}
        {/*</div>*/}
        <div className={style.box}>
          <label style={{ fontSize: "11px" }}>
            <input
              type="checkbox"
              checked={privacyConsent}
              onChange={(e) => setPrivacyConsent(e.target.checked)}
            />
            Vista l'informativa privacy, prendo atto che il trattamento dei miei
            dati è necessario all’erogazione dei servizi per le finalità
            descritte all'art. 3 lett. a) e che potrà essere effettuato anche
            per l'adempimento degli obblighi di legge descritti all'art. 3 lett.
            f), nonché per finalità di interesse legittimo descritte agli art.3
            lett. c) e)
          </label>
        </div>
        {/*<div className={style.box}>*/}
        {/*  <label style={{ fontSize: "11px" }}>*/}
        {/*    <input*/}
        {/*      type="checkbox"*/}
        {/*      checked={trattamentoConsent}*/}
        {/*      onChange={(e) => setTrattamentoConsent(e.target.checked)}*/}
        {/*    />*/}
        {/*    <span style={{ fontSize: "11px" }}>*/}
        {/*      Acconsento al trattamento dei miei dati personali per l’invio*/}
        {/*      di comunicazioni promozionali, offerta di prodotti e/o*/}
        {/*      servizi, anche di terzi, mediante ogni mezzo, tra cui in*/}
        {/*      particolare l’uso di telefono con operatore e/o sistemi*/}
        {/*      automatizzati (es. SMS, e-mail, ecc.), finalità descritta*/}
        {/*      all'art. 3 lett. b)*/}
        {/*    </span>*/}
        {/*  </label>*/}
        {/*</div>*/}
        {/*<pre>{JSON.stringify(leadData, null, 2)}</pre>*/}
      </div>
      <Button
        style={{ marginTop: "1em", width: "100%" }}
        variant="contained"
        disabled={!privacyConsent || sending}
        onClick={handleSubmitConsent}
      >
        {sending
          ? "Elaboro richiesta..."
          : !privacyConsent
            ? "Accetta privacy e consenso"
            : "Conferma e concludi"}
      </Button>
    </div>
  );
}

export default LeadConfirm;
